module.exports = __webpack_public_path__ + "96931ae89b0575d7f12d0d7ec3573ba9.pdf";